"use strict";
var MenuGroup = require('../helpers/menuGroup');
var Menu = function() {
  this.groups = [];
  this.show = false;
};
Menu.prototype = {
  createGroup: function() {
    var group = new MenuGroup();
    this.groups.push(group);
    return group;
  },
  addGroup: function(group) {
    this.groups.push(group);
  },
  calcShow: function() {
    this.show = false;
    for (var i = 0; i < this.groups.length; ++i) {
      this.groups[i].calcShow();
      if (this.groups[i].show)
        this.show = true;
    }
  }
};
module.exports = Menu;
